export default "__VITE_ASSET__d80437b1__"